import React from "react";
import { useState } from "react";
import {
  FaBars,
  FaFacebook,
  FaTimes,
  FaUser,
  FaStrava,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
// import {HiOutlineMail} from 'react-icons/hi'
// import {BsFillPersonLinesFill} from 'react-icons/bs'

import qhubhekaLogo from "../assests/qhubhekaLogo.PNG";
// import { Link } from 'react-scroll'
// import Footer from './Footer'

export default function Navbar() {
  const [nav, setNav] = useState(false);
  const [gal, setGal] = useState(false);
  const handleClick = () => setNav(!nav);
  const handleGallery = () => setGal(!gal);

  return (
    <div className="">
      {/* strip */}
      <div className="bg-[#001ea1] text-white flex ">
        <div className="flex justify-end items-end  w-full">
          <a
            className="w-10  text-white   "
            href="https://www.strava.com/clubs/786066/group_events/944626"
            target="_blank"
          >
            <FaStrava size={20} />
          </a>

          <a
            className="w-10   text-white  "
            href="https://www.facebook.com/p/Qhubeka-AC-100075743505495/"
            target="_blank"
          >
            <FaFacebook size={20} />
          </a>

          <a
            className="w-10  text-white   "
            href="https://www.instagram.com/qhubeka_athletic_club/?locale=no&hl=en"
            target="_blank"
          >
            <FaInstagram size={20} />
          </a>

          <a
            className="w-10   text-white   "
            href="https://www.tiktok.com/@qhubeka_athletic_club?lang=en&is_from_webapp=1&sender_device=mobile&sender_web_id=7454201295919564304"
            target="_blank"
          >
            <FaTiktok size={20} />
          </a>
        </div>
      </div>

      <div className="absolute top-5 w-full h-[100px] flex justify-between items-center px-1 bg-[#ffffff] text-black z-10 ">
        <div className=" absolute">
          <a href="/">
            <img
              src={qhubhekaLogo}
              className="w-[200px] pl-10  object-contain relative"
              alt="Welcome Image"
              loading="lazy"
            />
          </a>
        </div>

        {/*Menu*/}

        <ul className=" hidden md:flex text-[#001ea1] md:left-0 md:pl-52">
          <li>
            {" "}
            <a href="/">
              <button className=" text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold">
                {" "}
                Home
              </button>
            </a>{" "}
          </li>
          <li>
            {" "}
            <a href="/AboutUs">
              <button className="  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold">
                {" "}
                About Us
              </button>
            </a>
          </li>
          <li className="px-[2px]">
            {" "}
            <a href="/MemberRegistration">
              <button className="  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold ">
                {" "}
                Join Us
              </button>
            </a>
          </li>
          <li>
            {" "}
            <a href="/Training">
              <button className="  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold">
                {" "}
                Training
              </button>
            </a>
          </li>
          <li>
            <button
              className="    flex flex-col-1 rounded-lg m-2  "
              onClick={handleGallery}
            >
              Gallery
              <ul
                className={
                  !gal
                    ? "hidden"
                    : " pt-8 text-[#001ea1] text-left rounded-3xl  bg-[#ffffff] absolute -z-10  "
                }
              >
                <li>
                  <a href="/EmblaCarousel">Qhubeka Moments</a>
                </li>
                <li>
                  <a href="/ComradesShoot">Comrades shoot 2024</a>
                </li>
                <li>
                  <a href="/Comrades2023">Comrades shoot 2023</a>
                </li>
                <li>
                  <a href="/Galla2024">Gala Dinner 2024</a>
                </li>
                <li>
                  <a href="/Galla2023">Gala Dinner 2023</a>
                </li>
                <li>
                  <a href="/GalaDinner">Gala Dinner 2022</a>
                </li>
              </ul>
            </button>
          </li>
          <li>
            {" "}
            <a href="/Events">
              {" "}
              <button className="  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold ">
                {" "}
                Events
              </button>
            </a>
          </li>
          <li>
            {" "}
            <a href="FAQ">
              <button className="  text-center  flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold">
                {" "}
                FAQ
              </button>
            </a>
          </li>
          <li>
            {" "}
            <a href="/ContactUs">
              <button className="  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold">
                {" "}
                Contact Us
              </button>
            </a>
          </li>

          {/* <li> 
                <a href='/MemberLogin'>
                <button 
                className='  text-center items-center flex rounded-lg m-2 hover:weight:bold hover:scale-110 hover:font-bold'>
                <FaUser/>
                 </button></a></li>   */}
        </ul>

        {/*hamburger*/}
        <div onClick={handleClick} className=" md:hidden z-10 absolute right-3">
          {!nav ? <FaBars /> : <FaTimes />}
        </div>

        {/* gallery dropdown menu options */}

        {/*Mobile Menu */}
        <ul
          className={
            !nav
              ? "hidden"
              : "md:hidden pt-16  text-[#001ea1]  font-bold absolute top-0 right-0  md:w-48 rounded-3xl bg-[#ffffff] flex flex-col justify-top "
          }
        >
          <li>
            {" "}
            <a href="/">Home</a>
          </li>
          <li>
            {" "}
            <a href="/AboutUs">About Us</a>
          </li>
          <li>
            {" "}
            <a href="/MemberRegistration">Join Us</a>
          </li>
          <li>
            {" "}
            <a href="/Training">Training</a>
          </li>
          <li className={!gal ? "" : "pb-40 w-56"}>
            <button
              className="    flex flex-col-1 rounded-lg   "
              onClick={handleGallery}
            >
              Gallery
            </button>
            <ul
              className={
                !gal
                  ? "hidden"
                  : "  text-[#001ea1] font-normal text-left  bg-[#ffffff] absolute z-10  "
              }
            >
              <li>
                <a href="/EmblaCarousel">Qhubeka Moments</a>
              </li>
              <li>
                <a href="/ComradesShoot">Comrades shoot 2024</a>
              </li>
              <li>
                <a href="/Comrades2023">Comrades shoots 2023</a>
              </li>
              <li>
                <a href="/Galla2024">Gala Dinner 2024</a>
              </li>
              <li>
                <a href="/Galla2023">Gala Dinner 2023</a>
              </li>
              <li>
                <a href="/GalaDinner">Gala Dinner 2022</a>
              </li>
            </ul>
          </li>
          <li>
            {" "}
            <a href="/Events">Events</a>
          </li>
          <li>
            {" "}
            <a href="/FAQ">FAQ</a>
          </li>
          <li>
            <a href="/ContactUs">Contact Us</a>
          </li>

          {/* <li><a href='/Carousel'>Carousel</a></li> */}
        </ul>
        {/* <div className=" text-[#001ea1] left-20">
          <a href="/MemberLogin">
            <FaUser />
          </a>
        </div> */}

        {/*Social Icons*/}

        <div className=" hidden lg:flex fixed flex-col top-[38%] left-0 ">
          <ul>
            <li className="w-[150px] h-[60px] flex justify-between">
              <a
                className="w-full  flex justify-between items-center text-gray-300 ml-[-90px] hover:ml-[-10px] duration-500 bg-orange-500 px-0"
                href="https://www.strava.com/clubs/786066/group_events/944626"
                target="_blank"
              >
                Strava <FaStrava size={40} />
              </a>
            </li>
            <li className="w-[150px] h-[60px] flex justify-between">
              <a
                className="w-full  flex justify-between items-center text-gray-300 ml-[-90px] hover:ml-[-10px] duration-500 bg-blue-500 px-0"
                href="https://www.facebook.com/p/Qhubeka-AC-100075743505495/"
                target="_blank"
              >
                Facebook <FaFacebook size={40} />
              </a>
            </li>
            <li className="w-[150px] h-[60px] flex justify-between">
              <a
                className="w-full  flex justify-between items-center text-gray-300 ml-[-90px] hover:ml-[-10px] duration-500 bg-pink-600 px-0"
                href="https://www.instagram.com/qhubeka_athletic_club/?locale=no&hl=en"
                target="_blank"
              >
                Instagram <FaInstagram size={40} />
              </a>
            </li>

            <li className="w-[150px] h-[60px] flex justify-between">
              <a
                className="w-full  flex justify-between items-center text-gray-300 ml-[-90px] hover:ml-[-10px] duration-500 bg-black px-0"
                href="https://x.com/QhubekaAC"
                target="_blank"
              >
                Twitter <FaTiktok size={40} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
